module.exports = __webpack_public_path__ + "img/re5.652243ed.png";